import httpClient from './httpClient';

const missionService = {
    loadContact(pkClient) {
        return httpClient.get(`/api/adv/mission/${pkClient}/contacts`);
    },
    getPathologies(pkClient) {
        return httpClient.get(`/api/adv/mission/${pkClient}`);
    },
    getMissionEnCours() {
        return httpClient.get('/api/adv/mission/current');
    },
    applyMission(data) {
        return httpClient.post('/postuler-mission', data);
    },
    cancelOffer(data) {
        return httpClient.post('/annuler-offre', data);
    },
    createMissionEnCours() {
        return httpClient.post('/missions/trouver-missions-court')
    },
    getCandidatures(){
        return httpClient.post('/missions/candidatures-adv')
    }
}

export default missionService;